import React from "react";
import "./categorysection.css";
// import { SiCssdesignawards } from "react-icons/si";
import "./../style/common.css";
import { Link } from "react-router-dom";

const categories = [
  {
    title: "Aussie Breakfast",
    image: "/Images/c1-breakfast.png",
    link: "/aussie-breakfast-in-mandurah",
  },
  {
    title: "Indo–Chinese",
    image: "/Images/indo-chinese.png",
    link: "/indo-chinese-in-mandurah",
  },
  {
    title: "Indian Street Food",
    image: "/Images/indian-street.png",
    link: "/indian-street-food-in-mandurah",
  },
  {
    title: "Indian Cuisine",
    image: "/Images/c4-category.png",
    link: "/indian-cuisine-in-mandurah",
  },
];

const CategorySection = () => {
  return (
    <div className="category-section">
      <img
        src="/Images/top-left.png"
        alt="Top Left Decor"
        className="decor-home top-left"
        loading="lazy"
      />
      <img
        src="./Images/bottom-right.png"
        alt="Bottom Right Decor"
        className="decor-home bottom-right"
        loading="lazy"
      />

      {/* <p className="subheading">
        {" "}
        <SiCssdesignawards /> Lorem Ipsum Sub Heading
      </p> */}
      <h2 className="heading">Our Top Categories</h2>

      <div className="category-list">
        {categories.map((cat, index) => (
          <Link to={cat.link} key={index} className="category-card">
            <img src={cat.image} alt={cat.title} loading="lazy" />
            <p>{cat.title}</p>
            <div className="overlay-category" />
          </Link>
        ))}
      </div>

      {/* <button className="explore-button">Explore All</button> */}
    </div>
  );
};

export default CategorySection;
